import humps from "humps";

export const decamelizeKeys = object => {
  return humps.decamelizeKeys(object, (key, convert, options) => {
    switch (key) {
      case "last4SSN":
        return "last_4_ssn";
      default:
        return convert(key, options);
    }
  });
};
